module.exports = __webpack_public_path__ + "img/icon2.2f0f06e6.png";